import { Link } from "react-router";

import { ArrowRightIcon, FolderKanbanIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { TableCell, TableRow } from "@/components/ui/table";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

import { AccountMembership } from "@/features/account/types";
import { RoleBadge } from "@/features/members/components/RoleBadge";
import { formatAbsoluteDateTime, formatRelativeDate } from "@/shared/lib/utils/date";

interface AccountMembershipRowProps {
  membership: AccountMembership;
}

export function AccountMembershipRow({ membership }: AccountMembershipRowProps) {
  return (
    <TableRow>
      <TableCell>
        <div className="flex items-center gap-3">
          <div className="flex size-8 shrink-0 items-center justify-center bg-primary/10">
            <FolderKanbanIcon className="size-4 text-primary" />
          </div>
          <Link to={`/projects/${membership.projectId}`} className="text-sm font-medium hover:text-primary">
            {membership.projectName}
          </Link>
        </div>
      </TableCell>
      <TableCell>
        <RoleBadge role={membership.roleName} />
      </TableCell>
      <TableCell className="tabular-nums">{membership.openTicketCount}</TableCell>
      <TableCell>
        <Tooltip delayDuration={400}>
          <TooltipTrigger asChild>
            <span className="text-xs text-muted-foreground">{formatRelativeDate(membership.joinedAt)}</span>
          </TooltipTrigger>
          <TooltipContent>{formatAbsoluteDateTime(membership.joinedAt)}</TooltipContent>
        </Tooltip>
      </TableCell>
      <TableCell className="text-right">
        <Button variant="ghost" size="sm" asChild>
          <Link to={`/projects/${membership.projectId}`}>
            Open
            <ArrowRightIcon />
          </Link>
        </Button>
      </TableCell>
    </TableRow>
  );
}
